module.exports = __webpack_public_path__ + "media/app/assets/specializations/hunter/marksmanship-db1093ceb520459c1ebda4f987ddc9e5.png";